import axios from "axios";

// Phase 2D — Helper for admin acting as their linked driver.
//
// Reuses the SAME `sdrive_linked_driver_token` that the existing admin/driver
// switch already populates via AuthContext.linkDriver(). No new token is ever
// created or stored. No fallback to the admin token is ever attempted: if the
// linked driver token is missing/expired/invalid, the caller MUST handle the
// error explicitly (typically: prompt the admin to re-link).
//
// This goes through a RAW axios instance (not the shared `api` interceptor)
// so that:
//   1. We can attach a specific Authorization header without disturbing the
//      admin's active token.
//   2. A 401 response cannot accidentally trigger the global redirect-to-login
//      defined in lib/api.js.
const LINKED_DRIVER_TOKEN = "sdrive_linked_driver_token";
const LINKED_DRIVER_USER  = "sdrive_linked_driver_user";

const rawClient = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

export class LinkedDriverError extends Error {
  constructor(reason, message) {
    super(message);
    this.reason = reason;
  }
}

export function getLinkedDriverFromStorage() {
  try {
    const u = JSON.parse(localStorage.getItem(LINKED_DRIVER_USER) || "null");
    const t = localStorage.getItem(LINKED_DRIVER_TOKEN);
    if (!u || !t) return null;
    return { ...u, _token: t };
  } catch { return null; }
}

export async function callAsLinkedDriver(method, path, body) {
  const token = localStorage.getItem(LINKED_DRIVER_TOKEN);
  if (!token) {
    throw new LinkedDriverError(
      "missing_token",
      "Aucun chauffeur lié. Veuillez relier le compte chauffeur."
    );
  }
  try {
    const res = await rawClient.request({
      method,
      url: path,
      data: body,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (err) {
    const status = err.response?.status;
    if (status === 401) {
      // Linked driver token is expired/invalid. We do NOT clear it (the admin
      // can re-link via LinkedDriverCard), and we do NOT redirect.
      throw new LinkedDriverError(
        "expired_token",
        "Le lien chauffeur a expiré. Veuillez relier le compte chauffeur."
      );
    }
    if (status === 403) {
      throw new LinkedDriverError(
        "forbidden",
        err.response?.data?.detail || "Action refusée par le backend."
      );
    }
    throw err;
  }
}
